import { render, staticRenderFns } from "./btnSubmit.vue?vue&type=template&id=3bcda6de&scoped=true&"
import script from "./btnSubmit.vue?vue&type=script&lang=js&"
export * from "./btnSubmit.vue?vue&type=script&lang=js&"
import style0 from "./btnSubmit.vue?vue&type=style&index=0&id=3bcda6de&prod&lang=scss&scoped=true&"
import style1 from "./btnSubmit.vue?vue&type=style&index=1&id=3bcda6de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcda6de",
  null
  
)

export default component.exports